<template>
  <v-col
    v-bind="{ ...containerProps, ...containerOptions }"
    class="helmi-radio-group"
  >
    <v-radio-group
      v-model="modelValue"
      v-bind="$attrs"
    >
      <template #label>
        <div class="text-body-2">
          <b :class="colors.text">{{ chapter }}</b>
          {{ $attrs.label }}
        </div>
      </template>
      <v-radio
        v-for="(option, index) in options"
        :key="index"
        :color="colors.base"
        :value="option"
      >
        <template #label>
          <div class="text-body-2">
            {{ option }}
          </div>
        </template>
      </v-radio>
    </v-radio-group>
    <v-fade-transition>
      <!-- v-if="modelValue" -->
      <v-btn
        :color="colors.base"
        :disabled="modelValue === ''"
        class="helmi-radio-group__clear text-body-2"
        small
        text
        @click="modelValue = ''"
      >
        Poista valinta
      </v-btn>
    </v-fade-transition>
  </v-col>
</template>

<script>
import { EventBus } from '@/utils';

export default {
  name: 'HelmiRadioGroup',

  inheritAttrs: false,

  props: {
    chapter: {
      type: String,
      default: '',
    },

    colors: {
      type: Object,
      default: () => ({
        base: 'primary',
        text: 'primary--text',
      }),
    },

    containerOptions: {
      type: Object,
      default: () => ({}),
    },

    containerProps: {
      type: Object,
      default: () => ({}),
    },

    options: {
      type: Array,
      default: () => [{}],
    },

    propertyValue: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    defaultValue: '',
    modelValue: '',
  }),

  computed: {
    label() {
      return `${this.chapter} ${this.$attrs.label}`;
    },
  },

  watch: {
    // Handles internal model changes.
    modelValue(newVal) {
      this.$emit('input', newVal);
      this.$emit('evaluate', newVal, this.$attrs.id);
    },

    // Handles external model changes.
    '$attrs.value': {
      handler(val) {
        this.modelValue = val;
      },
      immediate: true,
    },
  },

  mounted() {
    EventBus.$on('FORM_RESET', this.resetValue);
  },

  methods: {
    resetValue() {
      this.modelValue = this.propertyValue || this.defaultValue;
    },
  },
};
</script>

<style lang="scss">
.helmi-radio-group {
  position: relative;

  &,
  &.ma-0 {
    margin-bottom: 16px !important;
  }

  &__clear {
    position: absolute;
    bottom: -4px;
    left: 12px;
  }
}
</style>
